import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { CardHeaders } from '../../../../../userProfile/src/domain/UserInfo/entities';
import { DownloadTypes } from '../../../../../content-composer/src/components/Generic/FileDownload/FileDownload';
import { ICardRepository } from '../entities/ICardRepository';
import { ICardService } from '../entities/ICardService';
import { CardTransactionDetails, CardTransactionsDownloadResponseBody } from '../entities/CardTransaction';
import { FreezeCardResponseBody } from '../entities/Card/FreezeCardResponseDTO';
import {
  CardDetailsRequestBody,
  CardDetailsResponseBody,
  CardInfoListRequestBody,
  CardInfoListResponseBody,
  CardTransactionsResponseBody,
  CardTransactionsRequestBody,
  CorporateCardInfoListRequestBody,
  CardTermsRequestBody,
  PartyIdentification,
  CardInfoListFilter,
} from '../../../types';
import { CardAction } from '../../../contexts/CardActions';

export class CardServiceImpl implements ICardService {
  itemRepo: ICardRepository;

  constructor(ir: ICardRepository) {
    this.itemRepo = ir;
    this.GetIndividualCards = this.GetIndividualCards.bind(this);
    this.GetCorporateCards = this.GetCorporateCards.bind(this);
    this.GetCardTransactions = this.GetCardTransactions.bind(this);
    this.GetCardTransactionDetails = this.GetCardTransactionDetails.bind(this);
    this.GetTopUpAuthorization = this.GetTopUpAuthorization.bind(this);
    this.PostTopUpCard = this.PostTopUpCard.bind(this);
    this.FreezeCardAction = this.FreezeCardAction.bind(this);
    this.GetCardDetails = this.GetCardDetails.bind(this);
    this.GetCardTransactionsDownloadFile = this.GetCardTransactionsDownloadFile.bind(this);
    this.GetCardStatuses = this.GetCardStatuses.bind(this);
    this.GetTermsAndConditionsPDF = this.GetTermsAndConditionsPDF.bind(this);
    this.GetCardTransactionsDetailsDownloadFile = this.GetCardTransactionsDetailsDownloadFile.bind(this);
  }

  GetIndividualCards(data: CardInfoListRequestBody): Promise<CardInfoListResponseBody> {
    return this.itemRepo.GetIndividualCards(data);
  }

  GetCorporateCards(data: CorporateCardInfoListRequestBody): Promise<CardInfoListResponseBody> {
    return this.itemRepo.GetCorporateCards(data);
  }

  GetCardStatuses({ headers }: { headers: CardHeaders }): Promise<CardInfoListFilter> {
    return this.itemRepo.GetCardStatuses(headers);
  }

  GetCardDetails(data: CardDetailsRequestBody): Promise<CardDetailsResponseBody> {
    return this.itemRepo.GetCardDetails(data);
  }

  GetTermsAndConditionsPDF(data: CardTermsRequestBody): Promise<any> {
    return this.itemRepo.GetTermsAndConditionsPDF(data);
  }

  GetCardTransactions(data: CardTransactionsRequestBody): Promise<CardTransactionsResponseBody> {
    return this.itemRepo.GetCardTransactions(data);
  }

  GetCardTransactionDetails({
    customerId,
    transactionNo,
  }: {
    customerId: string;
    transactionNo: number;
  }): Promise<CardTransactionDetails> {
    return this.itemRepo.GetCardTransactionDetails(customerId, transactionNo);
  }

  GetTopUpAuthorization(): Promise<{
    authenticationRequestId: string;
    authenticationMethod: string;
    authorizationId: number;
  }> {
    return this.itemRepo.GetTopUpAuthorization();
  }

  PostTopUpCard(data: any): Promise<any> {
    return this.itemRepo.PostTopUpCard(data);
  }

  FreezeCardAction({
    headers,
    customerId,
    action,
    paymentCardIdentifications,
    successCallback,
  }: {
    headers: CardHeaders;
    customerId: string;
    action: CardAction;
    paymentCardIdentifications: PartyIdentification[];
    successCallback: SuccessCallback;
  }): Promise<FreezeCardResponseBody> {
    return this.itemRepo.FreezeCardAction(headers, customerId, action, paymentCardIdentifications, successCallback);
  }

  GetCardTransactionsDownloadFile(
    data: CardTransactionsRequestBody & { type: DownloadTypes },
  ): Promise<CardTransactionsDownloadResponseBody> {
    return this.itemRepo.GetCardTransactionsDownloadFile(data);
  }

  // TODO: DEPRECATED
  GetCardTransactionsDetailsDownloadFile(
    data: CardTransactionsRequestBody & { type: DownloadTypes },
  ): Promise<CardTransactionsDownloadResponseBody> {
    return this.itemRepo.GetCardTransactionsDetailsDownloadFile(data);
  }
}
